import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import GameComponent from "game/app/components/game/game-component";
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from "reactstrap";
import {push} from 'react-router-redux';

class BankruptcyModal extends GameComponent {

    constructor() {
        super();
    }

    toggle = () => {
        this.props.push(`/game/${this.getInstanceId()}/round-2/otazky`);
        this.props.sendInput(this.getInstanceId(), { type: 'close' });
    };

    render() {
        let activeEvent = this.getActiveEvent();
        let modalOpened = activeEvent && activeEvent.type === 'Game::Events::BankruptcyEvent';

        return (
            <div>
                <Modal isOpen={modalOpened} modalTransition={{ timeout: 200 }} backdropTransition={{ timeout: 200 }} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Bankrot</ModalHeader>
                    <ModalBody>
                        <p>Zkouškou života se vám nepodařilo projít. Výdaje jste měli vyšší, než kolik peněz jste měli k dispozici. Vrátíme vás zpátky k základním úkolům druhého kola, abyste si mohli své výdaje upravit před tím, než se do zkoušky života pustíte znovu. Bude vás to ale stát 10 chechtáků.</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.toggle}>Pokračovat</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        push: push
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(BankruptcyModal);
